const siteConfig = {
  brandName: "doszenith",
  logo: {
    text: "doszenith",
    monogram: "DZ",
    tagline: "GATHER · TASTE · SHARE",
    ariaLabel: "doszenith home",
  },
  description:
    "A spirited specialty-food market for remarkable cheese, charcuterie, pantry finds, sweets, and gifts made for sharing.",
  contact: {
    email: "grow@doszenith.life",
    address: "121 Market Lane, Philadelphia, PA 19106",
    hours: "Monday–Saturday, 9am–7pm ET",
  },
  currency: "USD",
  currencySymbol: "$",
  locale: "en-US",
  shippingRate: 9.99,
  nav: [
    { label: "Shop All", href: "/shop" },
    { label: "Gift Boxes", href: "/shop?category=Gift%20Boxes" },
    { label: "Cheese", href: "/shop?category=Cheese" },
    { label: "Charcuterie", href: "/shop?category=Charcuterie" },
    { label: "Pantry", href: "/shop?category=Pantry" },
    { label: "Sweets", href: "/shop?category=Sweets" },
    { label: "Clubs", href: "/shop?category=Clubs" },
    { label: "Our Story", href: "/about" },
  ],
  social: [],
  policyNav: [
    { label: "FAQs", href: "/faqs" },
    { label: "Privacy", href: "/privacy" },
    { label: "Cookies", href: "/cookies" },
    { label: "Terms", href: "/terms" },
    { label: "Shipping", href: "/shipping" },
    { label: "Returns", href: "/returns" },
  ],
};

export { siteConfig };
export default siteConfig;
